import _ from "lodash";

import api from "CommonCore/api";
import {
  setupLookups,
} from "App/shk-form-tab";
import {
  dateRange,
  formatNumber,
} from "CommonCore/l10n";
import {
  ANTRAGSTATUS,
  istArtTarifvertrag,
  istTypWerkvertrag,
  ROLLEN,
  VERTRAGSART_AUSWAEHLEN,
  VERTRAGSARTEN_LEHRAUFTRAG,
  VERTRAGSARTEN_SHK,
  VERTRAGSARTEN_TARIF,
  VERTRAGSARTEN_VORTRAG,
  VERTRAGSARTEN_WERKVERTRAG,
} from "App/constants";
import apifetch from "CommonCore/apifetch";
import {
  formatKonto,
} from "Apis/massnahme-api";
import TR from "Common/translate";

const istAntragsteller = {
  inject: ["user"],
  generator: user => () => user?.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER,
};

const lookupSbNutzer = {
  type: "select",
  // Choices für Editorauswahl sind auf User der Rolle dez4 beschränkt
  choices: lookup => _.map(lookup, l => ({ value: l.n_id, label: `${ l.n_vorname } ${ l.n_name }` })),
  inject: ["nutzersbLookup"],
  selector: lookup => id => {
    if (lookup) {
      const n = lookup[id];
      return n && `${ n.n_vorname } ${ n.n_name }`;
    }
  },
  filter: {
    filterbox: {
      choices: lookup => _.map(lookup, l => `${ l.n_vorname } ${ l.n_name }`),
      inject: ["nutzersbLookup"],
    },
    subquery: {
      inject: ["nutzersbLookup"],
      fields: { a_sb_nid: { alias: "value" } },
      generator: lookup => entity => {
        const l = lookup && lookup[entity.a_sb_nid];
        if (l) {
          return {
            value: `${ l.n_vorname } ${ l.n_name }`,
          };

          /*
           * wenn Nutzer nicht im Katalog gefunden wird, er aber gesetzt ist:
           * nicht null liefern, da der Filter das Feld sonst als leer interpretiert
           */
        } else if (entity.a_sb_nid) {
          return { value: "something_unmatchable" };
        }
      },
    },
  },
};

export const schema = {
  displayName: "Antrag",
  formatWithDefinitiveArticle: a => (`den Antrag '${ a.a_nr }'`),
  toUserString: a => (`Antrag '${ a.a_nr }'`),
  defaultSort: [{ field: "a_nr", reverse: true }, { field: "plan_beginn", reverse: false }],
  table: [
    {
      field: "a_nr",
      display: "Nummer",
      readonly: true,
      sortable: true,
    },
    {
      field: "v_anrede",
      display: "Anrede",
      inject: ["k_anrede"],
      selector: lookup => (value, entity) => {
        if (entity.antrag_person && entity.antrag_person[0].ap_kanid) {
          return _.get(_.find(lookup, item => item.kan_id === entity.antrag_person[0].ap_kanid), "kan_kbez");
        }

        return value;
      },
      filter: {
        filterbox: {
          inject: ["k_anrede"],
          choices: lookup => _.map(lookup, t => t.kan_kbez),
        },
        subquery: {
          inject: ["k_anrede"],
          fields: { v_anrede: { alias: "kan_kbez" } },
          generator: lookup => entity => {
            return lookup && entity && entity.antrag_person && _.find(lookup, anrede => anrede.kan_id === entity.antrag_person[0].ap_kanid);
          },
        },
      },
      readonly: true,
      sortable: true,
      hideFromDetail: true,
    },
    {
      field: "a_eingangsdat",
      display: "Eingangsdatum",
      type: "date",
      sortable: true,
      readonly: true,
    },
    {
      field: "a_fakultaet_eid",
      display: "Fakultät / zentrale Einrichtung",
      lookup: "k_einrichtung.select.e_id.e_bez",
      required: true,
      sortable: true,
    },
    {
      field: "v_einrichtungsverantwortlich",
      display: "Einrichtungsverantwortlich",
      selector: (value, entity) => _.map(entity.massnahmen, m => m.m_e_asp).join(", "),
      filter: {
        filterbox: "text",
        subquery: {
          fields: { v_einrichtungsverantwortlich: { alias: "m_e_asp" } },
          generator: entity => entity && entity.massnahmen,
        },
      },
      sortable: true,
      readonly: true,
      hideFromDetail: true,
    },
    {
      field: "ansprechpartner",
      display: TR("Ansprechpartner"),
      selector: (value, entity) => _.map(entity.massnahmen, m => m.m_asp).join(", "),
      filter: {
        filterbox: "text",
        subquery: {
          fields: { ansprechpartner: { alias: "m_asp" } },
          generator: entity => entity && entity.massnahmen,
        },
      },
      sortable: true,
      readonly: true,
    },
    {
      field: "n_name",
      display: TR("Antragsteller"),
      selector: (value, entity) => {
        // Wichtig: Nicht eingereichte Sätze haben keine Eintrag in antrag_person
        if (entity.antrag_person && entity.antrag_person[0].ap_name) {
          return entity.antrag_person[0].ap_name;
        }

          // Bis Einreichung Profildaten ausgeben
        return value;
      },
      filter: {
        filterbox: "text",
        subquery: {
          fields: { n_name: { alias: "name" } },
          generator: entity => {
            if (entity.antrag_person && entity.antrag_person[0].ap_name) {
              return { name: entity.antrag_person[0].ap_name };
            }

              // Bis Einreichung Profildaten ausgeben
            return { name: entity.n_name };
          },
        },
      },
      sortable: true,
      readonly: true,
    },
    {
      field: "n_vorname",
      display: "Vorname",
      selector: (value, entity) => {
        // Wichtig: Nicht eingereichte Sätze haben keine Eintrag in antrag_person
        if (entity.antrag_person && entity.antrag_person[0].ap_vorname) {
          return entity.antrag_person[0].ap_vorname;
        }

          // Bis Einreichung Profildaten ausgeben
        return value;
      },
      filter: {
        filterbox: "text",
        subquery: {
          fields: { n_vorname: { alias: "vorname" } },
          generator: entity => {
            if (entity.antrag_person && entity.antrag_person[0].ap_vorname) {
              return { vorname: entity.antrag_person[0].ap_vorname };
            }

              // Bis Einreichung Profildaten ausgeben
            return { vorname: entity.n_vorname };
          },
        },
      },
      sortable: true,
      readonly: true,
    },
    {
      field: "n_email",
      display: "E-Mail",
      sortable: true,
      readonly: true,
    },
    {
      field: "anz_massnahmen",
      display: "Anzahl zugeordneter Maßnahmen",
      type: "number",
      sortable: true,
      selector: (value, entity) => entity.massnahmen ? entity.massnahmen.length : "(keine)",
      readonly: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
      filter: {
        subquery: {
          fields: { anz_massnahmen: { alias: "length" } },
          generator: entity => entity.massnahmen,
        },
      },
    },
    {
      field: "pbp_id",
      display: "PBP-ID",
      maxlength: 10,
      readonly: true,
      selector: (value, entity) => {
        if (entity.massnahmen) {
          if (entity.massnahmen.length > 0) {
            const ret = entity.massnahmen.map(number => {
              if (number.m_pbpid != null) {
                return "PBP-" + number.m_pbpid + " ";
              }
            });
            return ret;
          }

          return "";
        }

        return "";
      },
      filter: {
        subquery: {
          fields: { pbp_id: { alias: "pbp_ids" } },
          generator: entity => {
            return { pbp_ids: entity.massnahmen && _.map(entity.massnahmen, mn => mn.m_pbpid).join() };
          },
        },
      },
    },
    {
      field: "a_sb_nid",
      display: TR("label_Zuständig"),
      lookup: { settings: lookupSbNutzer },
      sortable: true,
    },
    {
      field: "a_artid",
      display: "Vertragsart",
      type: "select",
      inject: ["k_vertragsartLookup"],
      selector: lookup => (value, entity) => {
        // PBP-2488 Für Tarif Antrag die Vertragsart aus den Tarifdaten nehmen wenn vorhanden
        const artid = entity.atd_artid || value;
        return entity && lookup && lookup[artid] && lookup[artid].art_kbez;
      },
      readonly: true, // antrag => istTypWerkvertrag(antrag.a_katid)||istTypLehrauftrag(antrag.a_katid),
      required: true,
      sortable: true,
      hideFromDetail: istAntragsteller,
      hideFromList: istAntragsteller,
      filter: {
        filterbox: {
          inject: ["k_vertragsartLookup"],
          choices: lookup => _.map(lookup, t => t.art_kbez),
        },
        subquery: {
          inject: ["k_vertragsartLookup"],
          fields: { a_artid: { alias: "art_kbez" } },
          generator: art => entity => {
            return art && entity && art[entity.atd_artid || entity.a_artid];
          },
        },
      },
    },
    {
      field: "a_katid",
      display: "Antragstyp",
      type: "select",
      inject: ["k_antragstypLookup"],
      choices: lookup => entity => {
        const w = VERTRAGSARTEN_WERKVERTRAG.indexOf(entity.a_artid) >= 0; // Antrag ist ein Werkvertrag
        return _.map(lookup, t => (w ? istTypWerkvertrag(t.kat_id) : !istTypWerkvertrag(t.kat_id)) && { value: t.kat_id, label: t.kat_kbez });
      },
      selector: lookup => (value, entity) => {
        return entity && lookup && lookup[value] && lookup[value].kat_kbez;
      },
      filter: {
        filterbox: {
          inject: ["k_antragstypLookup"],
          choices: lookup => _.map(lookup, t => t.kat_kbez),
        },
        subquery: {
          inject: ["k_antragstypLookup"],
          fields: { a_katid: { alias: "kat_kbez" } },
          generator: typ => entity => {
            return typ && entity && typ[entity.a_katid];
          },
        },
      },
      required: true,
      sortable: true,
    },
    {
      field: "plan_beginn",
      display: "geplanter Vertragsbeginn",
      type: "date",
      sortable: true,
      hideFromDetail: true,
      hideFromEditor: () => true,

    },
    {
      field: "plan_ende",
      display: "geplantes Vertragsende",
      type: "date",
      sortable: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
    },
    {
      field: "finanzierung",
      display: "Finanzierung",
      sortable: true,
      filter: {
        filterbox: "text",
        subquery: {
          fields: { finanzierung: { alias: "value" } },
          generator: entity => {
            let result = _.flatMapDeep(entity.massnahmen, m => _.map(m.massnahmefinanz, f => {
              // Kostenstelle + Budgetkonto ausgeben, wenn Budgetkonto nicht Kostenstelle entspricht, Prozent ausgeben wenn nicht 100%
              return formatKonto({ kostenstelle: f.mfi_kostenstelle, budgetkonto: f.mfi_budgetkonto }) +
                (f.mfi_prozent != 100 ? ` ${ f.mfi_prozent }%` : "");
            }));
            result = result.join(", ");
            return { value: result };
          },
        },
      },
      selector: (value, entity) => {
        let result = _.flatMapDeep(entity.massnahmen, m => _.map(m.massnahmefinanz, f => {
          // Kostenstelle + Budgetkonto ausgeben, wenn Budgetkonto nicht Kostenstelle entspricht, Prozent ausgeben wenn nicht 100%
          return formatKonto({ kostenstelle: f.mfi_kostenstelle, budgetkonto: f.mfi_budgetkonto }) +
            (f.mfi_prozent != 100 ? ` ${ f.mfi_prozent }%` : "");
        }));
        result = result.join(", ");
        return result;
      },
      hideFromDetail: true,
      hideFromEditor: () => true,
    },
    {
      field: "arbeitszeit",
      display: "Arbeitszeiten",
      sortable: true,
      filter: { hidden: true },
      selector: (value, entity) => {
        let result = _.flatMapDeep(entity.massnahmen, m => _.map(m.massnahmepaz, az => {
          return dateRange(az.mp_gueltigab, az.mp_gueltigbis) + " " + formatNumber(az.mp_std) + " Std.";
        }));
        result = result.join(", ");
        return result;
      },
      hideFromDetail: true,
      hideFromEditor: () => true,
    },

    {
      field: "a_asid",
      display: "Status",
      lookup: "k_antragstatus.select.as_id.as_bez",
      readonly: true,
      sortable: true,
    },
    {
      field: "ash_zeit",
      display: "Statusdatum",
      type: "date",
      readonly: true,
      sortable: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
      initiallyHidden: true,
    },
    {
      field: "meineer",
      display: "Anträge für mich relevant",
      type: "checkbox",
      readonly: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
      hideFromList: true,
    },

    {
      field: "zust_rolle",
      display: "Antrag bei Rolle",
      inject: ["k_antragstatusLookup", "rolleLookup"],
      selector: (status, rolle) => (value, entity) => {
        try {
          return entity && status && _.get(rolle, [status[entity.a_asid].as_roid, "ro_kbez"], "");
        } catch(err) {
          return err.message;
        }
      },
      filter: {
        filterbox: {
          inject: ["k_antragstatusLookup", "rolleLookup"],
          choices: (status, rolle) => _.map(rolle, r => r.ro_kbez),
        },
        subquery: {
          inject: ["k_antragstatusLookup", "rolleLookup"],
          fields: { zust_rolle: { alias: "value" } },
          generator: (status, rolle) => entity => {
            return status && rolle && entity && { value: status[entity.a_asid].as_roid ? rolle[status[entity.a_asid].as_roid].ro_kbez : "" };
          },
        },
      },
      readonly: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
      hideFromList: true,
    },
    {
      field: "wissma",
      display: "Wiss MA",
      type: "checkbox",
      sortable: true,
      selector: (value, entity) => {
        const result = _.find(_.flatMapDeep(entity.massnahmen, m => m.massnahmetarif), x => x?.mtf_ist_wiss);
        return result ? "Ja" : "Nein";
      },
      filter: {
        filterbox: {
          choices: ["Ja", "Nein"],
        },
        subquery: {
          fields: { wissma: { alias: "value" } },
          generator: entity => {
            return entity && { value: _.find(_.flatMapDeep(entity.massnahmen, m => m.massnahmetarif), x => x?.mtf_ist_wiss) ? "Ja" : "Nein" };
          },
        },
      },
      hideFromDetail: true,
      hideFromEditor: () => true,
    },
  ],
};

schema.table = setupLookups(schema);

// Auswahl Vertragsart einschränken
const vert = schema.table.find(f => f.field == "a_artid");
vert.choices = function(lookup) {
  return _.map(
    _.filter(lookup, l => VERTRAGSARTEN_SHK.indexOf(l.art_id) >= 0 || VERTRAGSARTEN_LEHRAUFTRAG.indexOf(l.art_id) >= 0),
    l => ({ value: l.art_id, label: `${ l.art_kbez }` }),
  );
};

// PBP-2483 Hierarchie aufbauen, damit Tarif Vertragsarten zusammengefasst ausgewählt werden können
vert.filter.filterbox.choices = function(lookup) {
  let choices = _.map(
    _.filter(lookup, l => VERTRAGSARTEN_SHK.indexOf(l.art_id) >= 0 || VERTRAGSARTEN_LEHRAUFTRAG.indexOf(l.art_id) >= 0 || l.art_id == VERTRAGSART_AUSWAEHLEN),
    l => ({ art_kbez: l.art_kbez, depth: 0 }),
  );
  const tarifarten = _.map(
    _.filter(lookup, l => VERTRAGSARTEN_TARIF.indexOf(l.art_id) >= 0),
    l => ({ art_kbez: l.art_kbez, depth: 1 }),
  );
  const parent = { depth: 0, art_kbez: "Tarifbeschäftigte", children: tarifarten };
  choices.push(parent);
  choices = choices.concat(tarifarten);
  return choices;
};
vert.filter.filterbox.hierarchy = {
  depth: art => art.depth,
  display: art => art.art_kbez,
};

const fak = schema.table.find(f => f.field == "a_fakultaet_eid");
fak.choices = lookup => _.map(_.filter(lookup, e => e.e_master_eid == e.e_id), l => ({ value: l.e_id, label: l.e_bez }));
fak.filter.filterbox.choices = lookup => _.sortBy(_.map(_.filter(lookup, e => e.e_master_eid == e.e_id), l => l.e_bez));


const desc = {
  id: "a_id",
  name: "antrag",
  endpoint: "/api/shkantrag/antrag",
  endpointParams: true,
  schema,
  breadcrumbs: {
    list: "Antrag",
    detail: n => schema.toUserString(n),
  },
};
const antragApi = api(desc);
export default antragApi;

export const antragParams = (value = null) => {
  return {
    abgeschlossen: (state, props) => {
      const { location } = props;
      return value || (!location || location.pathname.startsWith("/vertrag") ? "1" : "0");
    },
  };
};

// Angepasste Kopie für Verträge erzeugen
const x = _.cloneDeep(schema);
x.defaultFilters = [];
export const vertragschema = x;


export async function validateDokumente(user, antrag, lookups) {
  /*
   * Prüfen, ob Antrag die notwendigen Dokumente (zum Einreichen) aufweist
   * Liefert: Meldungen als Text oder NULL
   * Neue Version mit PBP-2511: /dokliste verwenden
   */
  const { k_pflichtanlageLookup } = lookups;

  // Dokumente finden, die für das Einreichen verpflichtend vorhanden sein müssen.
  const liste = await apifetch(`/api/shkantrag/antrag/dokliste/${ antrag.a_id }`);
  const msg = [];

  _.map(liste.data, f => {
    if (_.isEmpty(f.url_download) && f.url_upload && f.spf_verpflichtend) {
      // Pflichtdokument fehlt
      msg.push(_.get(k_pflichtanlageLookup, [f.kpf_id, "kpf_kbez"], "(Unbekanntes Dokument)"));
    }
  });

  if (!_.isEmpty(msg)) {
    // Fehlende Dokumente gefunden, Text formatieren
    return <span>Bitte fügen Sie dem Antrag folgende Dokumente als elektronische Anlage hinzu:<br /><br />
      <ul>{_.map(msg, x => <li>{x}</li>)}</ul></span>;
  }
  return null;
}

export function getSVA_pgd_data(antrag, lookups) {
  // Personendaten aus Antrag extrahieren und für Insert in SVA vorbereiten
  const { k_anredeLookup,
          k_familienstandLookup,
          k_staatLookup,
          k_vertragsartLookup,
          k_anredetitelLookup,
          k_astat_job_graduationLookup,
          user,
          k_krankenkasseLookup } = lookups;

  /*
   * PBP-1807: Studienbereich darf leer sein (WHK, Angestellte ...)
   * if (_.isEmpty(antrag.antrag_studienbereich)) {
   * let e = Error()
   * e.response = { nachricht: "Der Antrag hat keine Daten in 'antrag_studienbereich'" }
   * throw e
   * }
   */

  if (_.isEmpty(antrag.antrag_person)) {
    const e = Error();
    e.response = { nachricht: "Der Antrag hat keine Daten in 'antrag_person'" };
    throw e;
  }
  if (_.isEmpty(antrag.antrag_lbvperson) && !VERTRAGSARTEN_LEHRAUFTRAG.includes(antrag.a_artid)) {
    // Lehrauftrag hat keine Daten zu LBV-Person.
    const e = Error();
    e.response = { nachricht: "Der Antrag hat keine Daten in 'antrag_lbvperson'" };
    throw e;
  }

  try {
    const p = antrag.antrag_person[0];
    const asb = antrag.antrag_studienbereich && antrag.antrag_studienbereich[0];
    const alv = antrag.antrag_lbvperson ? antrag.antrag_lbvperson[0] : {};
    const als = antrag.antrag_lbvstatus ? antrag.antrag_lbvstatus[0] : {};
    const awg = antrag.antrag_werdegang ? antrag.antrag_werdegang[0] : {};

    const data = {
      pgd_name: p.ap_name, // Nachname der Person
      pgd_vornamen: p.ap_vorname, // Vorname(n)
      pgd_geburtsdatum: p.ap_gebdatum,
      pgd_geburtsort: p.ap_gebort,
      pgd_geburtsname: p.ap_gebname,
      pgd_geschlecht: String(k_anredeLookup[p.ap_kanid].kan_svakey),
      pgd_fam_stand: p.ap_kfaid ? k_familienstandLookup[p.ap_kfaid].kfa_svakey : "00",
      pgd_fam_stand_von: p.ap_famstandseit,
      pgd_staatsangehoer: k_staatLookup[p.ap_angehoerig_ksaid].ksa_svakey,
      pgd_plz: p.ap_plz,
      pgd_wohnort: p.ap_ort,
      pgd_strasse: p.ap_str,
      pgd_telefon: p.ap_tel,
      pgd_kategorie: k_vertragsartLookup[antrag.a_artid].art_svakey, // Mapping via Vertragsart macht der Service
      pgd_matrikelnummer: asb ? asb.asb_matrikelnummer : null,

      pgd_eintrittsdatum: _.min(_.map(antrag.massnahmen, m => m.m_gueltigab)), // (bei mehreren das früheste)
      pgd_taetig_datum: _.min(_.map(antrag.massnahmen, m => m.m_gueltigab)), // (bei mehreren das früheste)

      pgd_email: p.ap_email,

      k_astat_graduation_id: 4, // 4 - Abitur/Fachabitur

      pgd_geburtsland: k_staatLookup[p.ap_geb_ksaid].ksa_svakey,

      pgd_steuer_id: alv.alv_steuerid || p?.ap_steuerid || null,

      pgd_rentennummer: als.als_rvnr,
      atd_ist_wiss: antrag.atd_ist_wiss,

      pgd_titel: (p && p.ap_karid) ? k_anredetitelLookup[p.ap_karid].kar_svakey : null,
      kba_svakey: (awg && awg.awg_kbaid) ? k_astat_job_graduationLookup[awg.awg_kbaid].kba_svakey : null,
      n_svakuerzel: user.n_svakuerzel,
      kv_svakey: (als && als.als_kvid) ? k_krankenkasseLookup[als.als_kvid].kv_svakey : null,
      pgd_staatsangeh_2: p.ap_angehoerig2_ksaid ? k_staatLookup[p.ap_angehoerig2_ksaid].ksa_svakey : null,
    };

    return data;
  } catch(err) {
    const e = Error();
    e.response = { nachricht: err.message };
    throw e;
  }
}

export async function SVAExport(a_id, geldgeber) {
  /*
   * Daten das Antrages via API an SVA exportieren
   * (Errorhandling extern)
   */
  await apifetch("/api/shkexport/svaexport/bv", {
    method: "POST",
    body: { a_id: a_id, geldgeber: geldgeber },
  });
}

export function antragBearbeitbar(user, antrag) {
  // Prüfen, ob Sachbearbeiter Antrag bearbeiten darf

  /*
   * Hilfskraftverträge: nur Sachgebiet 4.3.4
   * Lehraufträge: nur Sachgebiet 4.3.4 (PBP-2158)
   * Werksverträge: nur Sachgebiet 1.3
   */

  if (antrag.a_asid == ANTRAGSTATUS.STATUS_UEBERARBEITEN) {
    return false; // Antragsteller überarbeitet, Sachb darf nicht gleichzeitig ändern
  }

  if (VERTRAGSARTEN_WERKVERTRAG.indexOf(antrag.a_artid) >= 0 || VERTRAGSARTEN_VORTRAG.indexOf(antrag.a_artid) >= 0) {
    return user.ro_id == ROLLEN.ROLLE_DEZ1_3;
  } else if (VERTRAGSARTEN_SHK.indexOf(antrag.a_artid) >= 0) {
    return user.ro_id == ROLLEN.ROLLE_SACHBEARBEITER_SHK;
  } else if (VERTRAGSARTEN_LEHRAUFTRAG.indexOf(antrag.a_artid) >= 0) {
    return user.ro_id == ROLLEN.ROLLE_SACHBEARBEITER_LEHRAUFTRAG;
  } else if (istArtTarifvertrag(antrag.a_artid)) {
    return [ROLLEN.ROLLE_SACHBEARBEITER_TARIF, ROLLEN.ROLLE_SACHGEBIETSLEITUNG].includes(user.ro_id);
  }

    // noch nicht implementierte Vertragsart
  return false;
}

export function checkAntragZuständigkeitsWechsel(antrag, user) {
  // Prüfen, ob der Antrag vom angegebenen Nutzer übernommen werden darf
  return antragBearbeitbar(user, antrag) && antrag.a_sb_nid != user.n_id;
}

export async function PREntscheidungOk(a_id) {
  const result = await apifetch(`/api/shkantrag/personalrat/zustimmung/${ a_id }`);
  if (result && result.data && result.data[0]) {
    const pr = result.data[0];
    // Prüfen ob in alle Entscheidungen getroffen (gefüllt) wurden
    return pr.apr_stimmtmassnahmezu != null
      && pr.apr_stimmteingruppierungzu != null
      && pr.apr_stimmtbefristungzu != null
      && pr.apr_stimmtmassnahmezu != undefined
      && pr.apr_stimmteingruppierungzu != undefined
      && pr.apr_stimmtbefristungzu != undefined;
  }
  return false; // keine Daten
}
